export class GetQualificationTrainingsOverview {
  static readonly type = '[QualificationTrainings] Get QualificationTrainings';
  constructor(
    public readonly params: {
      pageNumber: number;
      pageSize: number;
      relations: string[];
      lang: string;
      userIds?: string[];
      qualificationCategoryIds?: string[];
      userOrganizationalUnitIds?: string[];
      statuses?: string[];
      searchText?: string;
    },
  ) {}
}

export class ResetQualificationTrainingsOverviewDetails {
  static readonly type =
    '[QualificationTrainings] Reset QualificationTrainings Details';
}

export class GetQualificationTrainingsOverviewDetails {
  static readonly type =
    '[QualificationTrainings] Get QualificationTrainings details';
  constructor(
    public readonly qualificationTrainingId: string,
    public readonly userId: string,
  ) {}
}

export class OpenQualificationTrainingsOverviewDetailsDrawer {
  static readonly type =
    '[QualificationTrainings] Open QualificationTrainings Drawer';
  constructor(public readonly isOpen: boolean) {}
}
